<template lang="pug">
.depo-tracker.depo-float.pointer(
  v-if="showBar && $helpers.timingFilter('2026-08-17 00:00', '2026-08-31 23:59')"
  ref='tracker' 
  :style="{ left: x + 'px', top: y + 'px' }" 
  @mousedown="startDrag"
  @touchstart="startDrag" 
)
  //- .depo-close(style="width:20px;font-size:18px;top:0px" @click.stop="closeBar")
  .depo-close(
    @mousedown.stop.prevent="onCloseClick"
    @touchstart.stop.prevent="onCloseClick"
  )
    i.fa-solid.fa-circle-xmark
  .depo-progress
    img.depo-icon(v-if="$helpers.timingFilter('2026-08-17 00:00', '2026-08-31 23:59')" src='new/img/depo-bar/1957.png' draggable="false")
    //- img.depo-icon(v-if="$helpers.timingFilter('2026-06-01 00:00', '2026-06-12 23:59')" src='new/img/depo-bar/win-RM2333.png' draggable="false")
    //- img.depo-icon(src='new/img/depo-bar/win-RM2300.png' draggable="false")
    //- img.depo-icon(v-else src='new/img/depo-bar/month10.gif' draggable="false")
    .depo-bar
      //- img.depoinfo-icon(v-if="$helpers.timingFilter('2025-11-01 00:00')" src="/new/img/depo-bar/info11.png")
      //- img.depoinfo-icon(v-else src="/new/img/depo-bar/info10.png")
      .progress.position-relative(v-if="$helpers.timingFilter('2026-05-18 00:00', '2026-05-31 23:59')")
        .progress-bar.progress-bar-striped(role='progressbar' :aria-valuenow='depoProgress' aria-valuemin='0' aria-valuemax='100' :style="'width:'+depoProgress+'%'") 
        .progress-text  {{$numeral(depoAmount).format("0,0.00")}} / {{$numeral(targetAmount).format("0,0.00")}}
      .progress.position-relative.progress2(v-if="$helpers.timingFilter('2026-08-17 00:00', '2026-08-31 23:59')")
        .progress-bar.progress-bar-striped(role='progressbar' :aria-valuenow='depoProgress' aria-valuemin='0' aria-valuemax='100' :style="'width:'+depoProgress+'%'") 
        .progress-text  {{$numeral(depoAmount).format("0,0.00")}} / {{$numeral(targetAmount).format("0,0.00")}}
      //- img.depotime-icon(v-if="$helpers.timingFilter('2025-11-01 00:00')" src="/new/img/depo-bar/month11.png")
      //- img.depotime-icon(v-else src="/new/img/depo-bar/monthly10.png")
</template>
<script>
import { EventBus } from '@/store/event';
export default{
  data(){
    if(this.$helpers.timingFilter('2026-05-18 00:00', '2026-05-31 23:59')){
      var ta = 1999
    }else{
      var ta = 1957
    }
    return{
      depoAmount:"",
      targetAmount: ta,
      depoProgress: 0,
      isDragging: false,
      x: null, // Default to null (will be set later)
      y: null,
      offsetX: 0,
      offsetY: 0,
      clickAllowed: true, // Allows click only when there's no drag
      showBar:true,
      closeClicked: false,
    }
  },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
  },
  watch:{
    sessionToken(newState, oldState){
      if(newState === '' || newState === undefined){
        this.depoAmount = ""
        this.depoProgress = 0
      }else{
        if(this.$helpers.timingFilter('2025-08-01 00:00')){
          this.depositTrackerv2()
        }else{
          this.depositTracker()
        }
        
      }
    }
  },
  mounted(){
    // if(this.$helpers.timingFilter('2025-08-01 00:00')){
    //   this.depositTrackerv2()
    // }else{
    //   this.depositTracker()
    // }
    this.depositTracker()
    const tracker = this.$refs.tracker;
    if (tracker) {
      const rect = tracker.getBoundingClientRect();
      this.x = rect.left;
      if(window.innerWidth >= 768){
        this.y = rect.top + 250;
      }else{
        this.y = rect.top + 150;
      }
      
    }
    window.addEventListener("mouseup", this.checkStatus);
    window.addEventListener("touchend", this.checkStatus);
  },
  beforeDestroy() {
    window.removeEventListener("mouseup", this.endClick);
    window.removeEventListener("touchend", this.endClick);
  },
  methods:{
    closeBar(){
      this.showBar = false
    },
    onCloseClick() {
      this.showBar = false
    },
    startDrag(e) {
      e.preventDefault();
      this.isDragging = false; // Reset drag status
      this.clickAllowed = true; // Assume it's a click first
      this.closeClicked = false;

      const event = e.touches ? e.touches[0] : e;
      this.offsetX = event.clientX - this.x;
      this.offsetY = event.clientY - this.y;

      window.addEventListener("mousemove", this.onMove);
      // window.addEventListener("mouseup", this.endDrag);
      window.addEventListener("touchmove", this.onMove, { passive: false });
      // window.addEventListener("touchend", this.endDrag);
    },
    onMove(e) {
      if (!this.isDragging) {
        this.isDragging = true; // Confirm it's a drag
        this.clickAllowed = false; // Prevent click
      }
      e.preventDefault();
      const event = e.touches ? e.touches[0] : e;
      this.x = event.clientX - this.offsetX;
      this.y = event.clientY - this.offsetY;
    },
    // endDrag() {
    //   this.isDragging = false;
    //   window.removeEventListener("mousemove", this.onMove);
    //   window.removeEventListener("mouseup", this.endDrag);
    //   window.removeEventListener("touchmove", this.onMove);
    //   window.removeEventListener("touchend", this.endDrag);

    //   // Allow click after 200ms delay (prevents accidental click after dragging)
    //   setTimeout(() => {
    //     this.clickBlocked = false;
    //   }, 200);
    // },
    checkStatus(e){
      window.removeEventListener("mousemove", this.onMove);
      window.removeEventListener("touchmove", this.onMove);
      
      if (!this.clickAllowed || this.closeClicked) {
        this.closeClicked = false;
        return;
      }

      if (this.$refs.tracker && this.$refs.tracker.contains(e.target)) {
        // this.$router.push("/event").catch(error =>{})
        this.$router.push("/promotions").catch(error =>{})
        // if(this.isLoggedIn){
        //   if(this.depoAmount >= 3000){
        //     LiveChatWidget.call("maximize");
        //   }else{
        //     this.$router.push("/promotions").catch(error =>{}).finally(() => {
        //       this.$nextTick(() => {
        //         EventBus.$emit('custom', 130);
        //       });
        //     });
        //   }
        // }else{
        //   this.$router.push("/promotions").catch(error =>{}).finally(() => {
        //     this.$nextTick(() => {
        //       EventBus.$emit('custom', 130);
        //     });
        //   });
        // }
      }
      
      // this.$helpers.redirect('euro2024')
    },
    depositTracker(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/depositTracker", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              if(response.data.length > 0){
                this.depoAmount = response.data[0].deposit_amount
                this.targetAmount = response.data[0].target_amount
                this.depoProgress = parseFloat(response.data[0].deposit_amount) / parseFloat(response.data[0].target_amount) * 100
                if(this.depoProgress > 100){
                  this.depoProgress = 100
                }
              }else{
                // this.targetAmount = 1999
                if(this.$helpers.timingFilter('2026-05-18 00:00', '2026-05-31 23:59')){
                  this.targetAmount = 1999
                }else{
                  this.targetAmount = 1957
                }
              }
              
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }
    },
    depositTrackerv2(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/depositTrackerv2", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              if(response.data.info.length > 0){
                this.depoAmount = response.data.info[0].deposit_amount
                this.targetAmount =  response.data.info[0].target_amount
                // this.depoProgress = parseFloat(this.depoAmount) / this.targetAmount * 100
                switch(true){
                  case this.depoAmount >= 300 && this.depoAmount < 1000:
                    this.depoProgress = 100/8
                    break;
                  case this.depoAmount >= 1000 && this.depoAmount < 5000:
                    this.depoProgress = 100/8 * 2
                    break;
                  case this.depoAmount >= 5000 && this.depoAmount < 15000:
                    this.depoProgress = 100/8 * 3
                    break;
                  case this.depoAmount >= 15000 && this.depoAmount < 40000:
                    this.depoProgress = 100 /8 * 4
                    break;
                  case this.depoAmount >= 40000 && this.depoAmount < 100000:
                    this.depoProgress = 100 /8 * 5
                    break;
                  case this.depoAmount >= 100000 && this.depoAmount < 300000:
                    this.depoProgress = 100 /8 * 6
                    break;
                  case this.depoAmount >= 300000 && this.depoAmount < 1000000:
                    this.depoProgress = 100 /8 * 7
                    break;
                  // case this.depoAmount >= 500000 && this.depoAmount < 1000000:
                  //   this.depoProgress = 100 /10 * 8
                  //   break;
                  // case this.depoAmount >= 1000000 && this.depoAmount < 2000000:
                  //   this.depoProgress = 100 /10 * 9
                  //   break;
                  case this.depoAmount >= 1000000 :
                    this.depoProgress = 100
                    break;
                  default:
                    this.depoProgress = 0
                }
              }else{
                if(this.$helpers.timingFilter('2025-09-01 00:00')){
                  this.targetAmount = 1000000
                }else{
                  this.targetAmount = 1000000
                }
              }
              
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }
    }
  }
}
</script>
